<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; go back</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <h4 v-if="entity.parent !== null">
          Editing {{ tariffName }}
          <div class="btn btn-primary" @click="back">Back</div>
        </h4>
        <div class="btn btn-primary" @click="back" v-else>Back</div>
        <div v-if="tab === 'main'">
          <div class="clearfix" slot="admin-content" id="location-content">
            <div class="col-xs-12 gap" v-if="entity.id">
              <div class="text-center">
                <div class="shadow platform">
                  <div class="inner-tab-outer">
                      <span @click="visible = 'spreadsheet'" :class="[ visible=== 'spreadsheet' ? 'vis' : '' ]" style="border-right:none;">Info</span>
                      <span @click="visible = 'details'" :class="[ visible === 'details' ? 'vis' : '' ]">Basic</span>
                  </div>
                  <div class="inner-tab-outer">
                      <span @click="visible = 'lines'" :class="[ visible === 'lines' ? 'vis' : '' ]" style="border-top:none;border-right:none;">Line</span>
                      <span @click="visible = 'static'" :class="[ visible === 'static' ? 'vis' : '' ]" style="border-top:none;">Static</span>
                  </div>
                  <div class="inner-tab-outer">
                      <span @click="visible = 'notes'" :class="[ visible === 'notes' ? 'vis' : '' ]" style="border-top:none;;">Notes</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="visible === 'spreadsheet'">
            <div class="col-xs-12 col-sm-6 main-location-details left top-small">
              <div class="form-group">
                <label for="sd-name" class="form-label">Name</label>
                <input type="text" class="form-control" id="sd-name" v-model="entity.name"/>
              </div>
              <div class="form-group">
                <label for="sd-tariff" class="form-label">Tariff</label>
                <select class="form-control" id="sd-tariff" v-model="entity.tariff">
                  <option value=""></option>
                  <option v-for="(opt, i) in getSystemOptions('SPREADSHEET_LOOKUP')" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
              <div class="form-group">
                <label for="sd-tab" class="form-label">Tab Name</label>
                <input type="text" class="form-control" id="sd-tab" v-model="entity.tabName"/>
              </div>
              <div class="form-group" v-show="this.entity.id === null || this.entity.id === 0">
                <label for="sd-copy-from" class="form-label">Copy Details From</label>
                <select class="form-control" id="sd-copy-from" v-model="entity.copyDetailsFrom">
                  <option value=""></option>
                  <option v-for="(opt, i) in otherTariffDescriptors" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div v-show="visible === 'details'">
            <div class="clearfix bg-wht col-xs-12">
              <basic-details :dets="basicDetails" :parent="entity.id" :properties="tariffProperties" type="tariff"/>
            </div>
          </div>
          <div v-show="visible === 'lines'">
            <div class="clearfix bg-wht col-xs-12">
              <lines :dets="lines" :parent="entity.id" :properties="lineProperties"/>
            </div>
          </div>
          <div v-show="visible === 'static'">
            <div class="clearfix bg-wht col-xs-12">
              <tariff-details type="Static" :dets="staticDetails" :parent="entity.id" :main="this.parentId" />
            </div>
          </div>
          <div v-show="visible === 'notes'">
            <div class="clearfix bg-wht col-xs-12">
              <tariff-details type="Note" :dets="notes" :parent="entity.id" :main="this.parentId" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import BasicDetails from './BasicDetails'
  import TariffDetails from './TariffDetails'
  import Lines from './Lines'
  import { createRouteIdHash } from '../../../helpers/RouteHash'
  import SheetMixin from './SheetMixin'
  export default {
    name: 'SpreadsheetTariffDescriptor',
    mixins: [AdminEntityMixin, HelperMixin, SheetMixin],
    components: {
      Autocomplete,
      BasicDetails,
      TariffDetails,
      Lines
    },
    data () {
      return {
        init: false,
        visible: 'spreadsheet',
        transformForUpdate: {
          entityType: this.toMinus,
          tariff: this.toMinus
        },
        newEntityScreen: 'Admin - Spreadsheet Descriptors',
        editEntityScreen: 'Admin - Edit/View Spreadsheet Tariff Descriptor',
        tab: 'main',
        parentSearchResults: [],
        parentSearchText: '',
        children: [],
        otherTariffDescriptors: [],
        isNewScreen: false,
        entity: {
          id: null,
          parent: null,
          name: null,
          entityType: this.sheetDescLookup,
          tabName: null,
          property: null,
          spreadsheetType: null,
          data: null,
          dataType: null,
          tariff: null,
          cell: null,
          currency: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          mask: null,
          offset: null,
          dateFormat: null,
          actualValue: null,
          notificationEmail: null,
          repeating: null,
          allowOldTariffEndDateUpdate: null,
          skipRows: null,
          continuousNoOfRows: null,
          deleted: null,
          externalId: null,
          copyDetailsFrom: null
        },
        entityName: 'spreadsheet-descriptor',
        boxes: [
          {
            prop: 'entityType',
            id: 'id'
          },
          {
            prop: 'spreadsheetType',
            id: 'id'
          },
          {
            prop: 'data',
            id: 'id'
          },
          {
            prop: 'dataType',
            id: 'id'
          },
          {
            prop: 'tariff',
            id: 'id'
          }
        ]
      }
    },
    computed: {
      pathNew () {
        return this.$route.path.endsWith('new')
      },
      isValid () {
        return this.entity.entityType
      },
      lines () {
        return this.children.filter(({entityType}) => entityType === this.sheetDescDetail)
      },
      basicDetails () {
        return this.children.filter(({entityType}) => entityType === this.sheetDescLookupHeader)
      },
      staticDetails () {
        return this.children.filter(({entityType}) => entityType === this.sheetDescAddition)
      },
      notes () {
        return this.children.filter(({entityType}) => entityType === this.sheetDescNote)
      },
      parent () {
        return this.$store.getters['admin/spreadsheet-descriptor-parent']
      },
      parentId () {
        return typeof this.entity.parent === 'object' && this.entity.parent !== null ? this.entity.parent.id : this.entity.parent
      },
      tariffs () {
        return this.children.filter(obj => this.filterByCode(obj.entityType, this.sheetDescLookup))
      },
      tariffProperties () {
        return this.$store.getters['systemOption/tariffDescriptorProperty']
      },
      lineProperties () {
        return this.$store.getters['systemOption/lineDescriptorProperty']
      },
      tariffName () {
        return this.entity.name ? this.entity.name : this.getTariffType(this.entity.tariff)
      }
    },
    watch: {
      '$route' (newVal, oldVal) {
        this.setIsNew()
        this.getRelatedData()
      }
    },
    methods: {
      back () {
        this.$router.push({ name: 'Admin - Edit/View Spreadsheet Descriptor', params: { id: createRouteIdHash(this.parentId) } })
      },
      doSave (shouldExit) {
        this.$http.post(API.CREATE_ADMIN_ENTITY(this.entityName), { ...this.nullifyEntity, entityType: this.sheetDescLookup })
        .then(({data}) => {
          if (this.entity.copyDetailsFrom != null && this.entity.copyDetailsFrom != '') {
            this.$http.post(API.SPREADSHEET_CLONE_BY_LEVEL(data.id), {descriptorToCopyId: this.entity.copyDetailsFrom, level: 0})
              .then(() => { this.saveCallback(data, shouldExit) })
          } else { this.saveCallback(data, shouldExit) }
        })
        .catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'error', message: 'Entity not saved' })
        })
      },
      doUpdate (shouldExit) {
        this.$http.put(API.UPDATE_ADMIN_ENTITY(this.entityName, this.entity.id), { ...this.transformedEntity, entityType: this.sheetDescLookup })
        .then(({data}) => {
          event.$emit('toast', { type: 'success', message: 'Entity saved' })
          if (this.updateCacheOnSave) {
            this.$store.dispatch('systemOption/updateCache', { cacheProperty: this.cachePropertyName, data })
          }
          if (shouldExit) {
            this.$router.push({ name: 'Admin - Edit/View Spreadsheet Descriptor', params: { id: createRouteIdHash(this.parentId) } })
          }
        })
        .catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'error', message: 'Entity not saved' })
        })
      },
      saveCallback (data, shouldExit) {
        event.$emit('toast', {type: 'success', message: 'Entity saved'})
        if (this.updateCacheOnSave) {
          this.$store.dispatch('systemOption/updateCache', {cacheProperty: this.cachePropertyName, data})
        }
        if (!shouldExit) {
          this.goToEditScreen(data.id)
        } else {
          this.$router.push({
            name: 'Admin - Edit/View Spreadsheet Descriptor',
            params: {id: createRouteIdHash(this.parentId)}
          })
        }
      },
      setIsNew () {
        this.isNewScreen = this.pathNew
        if (this.isNewScreen) {
          this.clear()
        }
      },
      clear () {
        const base = this.getBaseData()
        for (let prop in base) {
          this.entity[prop] = base[prop]
        }
      },
      filterByid (entityType, id) {
        return entityType === id
      },
      updateParentSearchResults (str) {
        this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('spreadsheet-descriptor'), { params: { name: str } })
          .then(({data}) => {
            if (str === this.parentSearchText) {
              this.parentSearchResults = data
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getBaseData () {
        return {
          id: null,
          parent: this.parent,
          name: null,
          entityType: this.sheetDescLookup,
          tabName: null,
          property: null,
          spreadsheetType: null,
          data: null,
          dataType: null,
          tariff: null,
          cell: null,
          currency: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          mask: null,
          offset: null,
          dateFormat: null,
          actualValue: null,
          notificationEmail: null,
          repeating: null,
          allowOldTariffEndDateUpdate: null,
          skipRows: null,
          continuousNoOfRows: null,
          deleted: null,
          externalId: null
        }
      },
      getForParent (parent) {
        return this.$http.get(API.GET_ENTITIES('spreadsheet-descriptor'), {
          params: {
            parent: parent
          }
        })
      },
      getRelatedData () {
        if (this.entity.id !== null && this.entity.id > 0) {
          event.$emit('loading-on', { title: 'Setting up Spreadsheet' })
          this.getForParent(this.entity.id)
          .then(({data}) => {
            this.children = data.map(obj => this.unwrapData(obj))
            this.children.forEach((o) => {
              if (o.entityType === this.sheetDescAddition || o.entityType === this.sheetDescNote) {
                this.getForParent(o.id)
                .then(({data}) => {
                  this.$set(o, 'children', data.map(obj => this.unwrapData(obj)))
                }).catch(err => console.log(err))
              }
            })
          }).catch(err => {
            console.log(err)
            event.$emit('toast', { type: 'error', message: 'Not all children could be loaded. Please try refeshing or contact support' })
          }).then(() => {
            event.$emit('loading-off')
          })
        }
        this.getForParent(this.parentId).then(({data}) => {
          let results = data.map(obj => this.unwrapData(obj))
          results.forEach((o) => {
            if (o.entityType === this.sheetDescLookup) {
              let descriptorName = this.getSystemOption(o.tariff).name + ' ' + o.name
              this.otherTariffDescriptors.push({id: o.id, name: descriptorName})
            }
          })
        }).catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'error', message: 'Can not retrieve other lookup descriptors. Copying details from other lookup descriptors will not be available.' })
        }).then(() => {
          event.$emit('loading-off')
        })
      },
      getTariffType (id) {
        if (id !== null) {
          let o = this.getSystemOption(id)
          return o && o.hasOwnProperty('name') ? o.name : ''
        }
        return ''
      }
    },
    mounted () {
      this.setIsNew()
      this.getRelatedData()
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// TariffDescriptor.vue?236efc12